<template>
  <div class="main-page legalaid">
    <Menus title="农民工讨薪绿色通道" />
    <div class="container-flex">
      <div class="apply">
        <Collect />
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Collect from '../../components/DataCollect/Collect'
export default {
  components: {
    Menus,
    Collect
  }
}
</script>
